import classNames from 'classnames';
import { AppNextLink } from '@/features/app-next-link';
import { IconInfoCircle, IconMedalStar, IconSvg3DRotate, IconTruckTime } from '@/features/icons';
import Tooltip from '@/features/tooltip';
import { useVariantContextValues } from '../context/use-variant-context-values';
interface Props {
  className?: string;
  type: 'mobile' | 'desktop';
}
const PDPBuyingPolicies = ({
  className,
  type
}: Props) => {
  const {
    vendorDetails
  } = useVariantContextValues('pdp');
  const {
    tooltipText,
    vendorText,
    leadTimeText
  } = vendorDetails;
  const items = [{
    text: <span>
                    بازگشت کالا تا ۷ روز طبق{' '}
                    <AppNextLink prefetch={false} target='_blank' href='/faq?category=return' className='inline'>
                        شرایط مرجوعی
                    </AppNextLink>
                </span>,
    icon: <IconSvg3DRotate className='h-5 w-5 lg:h-6 lg:w-6' />,
    order: 'lg:order-2'
  }, {
    text: 'ضمانت اصالت و سلامت کالا',
    icon: <IconMedalStar className='h-5 w-5 lg:h-6 lg:w-6' />,
    order: 'lg:order-1'
  }];
  const showTooltip = !!tooltipText && !vendorText;
  const showVendorDetail = type === 'desktop' && (leadTimeText || showTooltip);
  if (showVendorDetail) {
    items.push({
      text: <div className='relative flex items-center gap-1.5'>
                    <span>{leadTimeText}</span>

                    {!!showTooltip && <Tooltip className='w-[367px] text-wrap text-right' tooltipText={tooltipText}>
                            <IconInfoCircle className='h-5 w-5 text-alert-info-dark' />
                        </Tooltip>}
                </div>,
      icon: <IconTruckTime className='h-5 w-5 lg:h-6 lg:w-6' />,
      order: 'lg:order-3'
    });
  }
  return <div className={classNames({
    'hidden flex-col gap-3 lg:flex': type === 'desktop',
    'mt-3 flex bg-surface-solid-50 px-3 lg:hidden': type === 'mobile'
  }, className)} data-sentry-component="PDPBuyingPolicies" data-sentry-source-file="pdp-buying-policies.tsx">
            {items.map((item, index) => !!item && <div className={classNames('relative flex items-center gap-1.5 text-center text-text-mediumGray', item.order, {
      'w-full grow flex-col px-0.5 py-3 after:absolute after:left-0 after:top-1/2 after:h-3/4 after:w-px after:-translate-y-1/2 after:bg-border-gray-light [&:last-child:after]:hidden [&:not(:last-child)]:ml-2 [&:not(:last-child)]:pl-2': type === 'mobile'
    })} key={index}>
                            {item.icon}
                            <span className='text-caption-10 lg:whitespace-nowrap lg:text-body-14'>{item.text}</span>
                        </div>)}
        </div>;
};
export default PDPBuyingPolicies;